// @ts-nocheck
import commonFormField from "@store/Themes/common/styleguide/components/forms/formField";
import { inputStyles as kishigoInputStyles } from "@store/Themes/kishigo/mixins/formField";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const formField: Styleguide["formField"] = {
    ...commonFormField,
    defaultProps: {
        ...commonFormField?.defaultProps,
        labelProps: {
            ...commonFormField?.defaultProps?.labelProps,
            css: css`
                ${commonFormField?.defaultProps?.labelProps?.css}
                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.small};
                    font-weight: ${theme.design.typography.weight.medium};
                `}
            `,
        },
        cssOverrides: {
            ...commonFormField?.defaultProps?.cssOverrides,
            formField: css`
                textarea {
                    ${kishigoInputStyles()}
                    padding: ${pxToRem(7, 10)};
                    border-radius: ${pxToRem(2)};
                }
            `,
            inputSelect: css`
                ${kishigoInputStyles()}
            `,
            descriptionWrapper: css`
                ${commonFormField?.defaultProps?.cssOverrides?.descriptionWrapper}

                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.small};
                    font-weight: ${theme.design.typography.weight.medium};
                `}
            `,
        },
    },
};

export default formField;
